(() => {
  if (window.__HJH_HOME_INITIALIZED__) return;
  window.__HJH_HOME_INITIALIZED__ = true;
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  const initHero = (root) => {
    if (!root || root.dataset.hjhInitialized === 'true') return;
    root.dataset.hjhInitialized = 'true';

    if (root.dataset.hideThemeHeader === 'true') {
      document.body.classList.add('hjh-hide-theme-header');
    } else if (!document.querySelector('[data-hjh-hero][data-hide-theme-header="true"]')) {
      document.body.classList.remove('hjh-hide-theme-header');
    }

    const toggle = root.querySelector('[data-hjh-menu-toggle]');
    const drawer = root.querySelector('[data-hjh-drawer]');
    const scrim = root.querySelector('[data-hjh-drawer-scrim]');
    const closeButton = root.querySelector('[data-hjh-drawer-close]');

    if (!toggle || !drawer || !scrim) return;

    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      scrim.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('aria-hidden', String(!open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        const firstLink = drawer.querySelector('a, button');
        firstLink?.focus({ preventScroll: true });
      } else {
        toggle.focus({ preventScroll: true });
      }
    };

    toggle.addEventListener('click', () => setOpen(!drawer.classList.contains('is-open')));
    closeButton?.addEventListener('click', () => setOpen(false));
    scrim.addEventListener('click', () => setOpen(false));
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
  };

  const initTestimonials = (root) => {
    if (!root || root.dataset.hjhSliderInitialized === 'true') return;
    root.dataset.hjhSliderInitialized = 'true';

    const track = root.querySelector('[data-hjh-testimonial-track]');
    const slides = [...root.querySelectorAll('[data-hjh-testimonial-slide]')];
    const dots = [...root.querySelectorAll('[data-hjh-testimonial-dot]')];
    if (!track || slides.length === 0 || dots.length === 0) return;

    const setActive = (index) => {
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        setActive(index);
      });
    });

    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
  const center = track.scrollLeft + track.clientWidth / 2;
        let closest = 0;
        let distance = Infinity;
        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const delta = Math.abs(center - slideCenter);
          if (delta < distance) {
            distance = delta;
            closest = index;
          }
        });
        setActive(closest);
      });
    }, { passive: true });

    setActive(0);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-hjh-hero]').forEach(initHero);
    scope.querySelectorAll('[data-hjh-testimonials]').forEach(initTestimonials);
  };

  ready(() => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('[data-hjh-hero][data-hide-theme-header="true"]')) {
      document.body.classList.remove('hjh-hide-theme-header');
    }
  });
})();
